import React from "react";
import PropTypes from "prop-types";
import FilterFieldsetHeader from "./filter-fieldset-header";
import FilterInputPairs from "./filter-input-pairs";
import Details from "./details";

class FilterFieldset extends React.Component {
  static propTypes = {
    displayName: PropTypes.string,
    fieldsetHeader: PropTypes.string,
    filters: PropTypes.array,
    filterOpen: PropTypes.bool,
    isMinimizable: PropTypes.bool,
    iconClass: PropTypes.string,
    idSuffix: PropTypes.string,
    keyName: PropTypes.string,
    isDeadEndTextSearch: PropTypes.bool,
    onClear: PropTypes.func,
    onToggleOpenFilters: PropTypes.func,
    onChange: PropTypes.func,
    seoKey: PropTypes.string,
    seoPossibleFilters: PropTypes.array,
    submitFilters: PropTypes.func,
    values: PropTypes.array,
  };

  clear = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.props.onClear(this.props.keyName);
  };

  onToggle = (component, open) => {
    this.props.onToggleOpenFilters(this.props.keyName, open);
  };

  onChange = filter => {
    this.props.onChange(filter);
    this.props.submitFilters({ isDeadEndTextSearch: !!this.props.isDeadEndTextSearch });
  };

  render() {
    var displayClear = !!(this.props.filters || []).length;

    return (
      <Details
        key={this.props.keyName}
        className={"filter-fieldset " + this.props.keyName}
        open={this.props.filterOpen}
        onToggle={this.onToggle}
        isMinimizable={this.props.isMinimizable}
        controlled={true}>
        <FilterFieldsetHeader
          displayClear={displayClear}
          iconClass={this.props.iconClass}
          isMinimizable={this.props.isMinimizable}
          onClear={this.clear}
          title={this.props.fieldsetHeader || this.props.displayName}
          count={this.props.filters?.length || 0}
        />
        <FilterInputPairs
          displayName={this.props.displayName}
          filters={this.props.filters}
          idSuffix={this.props.idSuffix}
          keyName={this.props.keyName}
          onChange={this.onChange}
          values={this.props.values}
          seoKey={this.props.seoKey}
          seoPossibleFilters={this.props.seoPossibleFilters}
        />
      </Details>
    );
  }
}

export default FilterFieldset;
